import { useMemo, useState } from 'react';

import { FilterElement } from '../types';

const hasSelectedOverflow = (
    filteredElements: FilterElement[],
    overflowThreshold: number
) =>
    filteredElements
        .slice(overflowThreshold)
        .some((element) => element.isSelected);

export function useExpandableList(
    filteredElements: FilterElement[],
    overflowThreshold: number
) {
    const forceShowAll = hasSelectedOverflow(
        filteredElements,
        overflowThreshold
    );
    const [showAll, setShowAll] = useState(forceShowAll);
    const { visibleFilters, hasOverflow } = useMemo(() => {
        const hasOverflow = overflowThreshold < filteredElements.length;
        const visibleFilters =
            showAll || overflowThreshold < 1
                ? filteredElements
                : filteredElements.slice(0, overflowThreshold);

        return { visibleFilters, hasOverflow };
    }, [filteredElements, overflowThreshold, showAll]);

    return { showAll, setShowAll, visibleFilters, hasOverflow };
}
